import React, { useState, useEffect } from 'react';
import { Card, Upload, Button, message, Image, Row, Col, Input } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';

const CHaciendaCliente = () => {
  const [remates, setRemates] = useState(null);
  const [precioPromCarne, setPrecioPromCarne] = useState('');
  const [loading, setLoading] = useState(false);
  const [empresaData, setEmpresaData] = useState(null);
  const { TextArea } = Input;

  const user = JSON.parse(localStorage.getItem('user'));
  const empresaId = user?.user?.idCooperativa;

  useEffect(() => {
    const fetchEmpresaData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/empresa/${empresaId}`);
        setEmpresaData(response.data);

        // Inicializar precioPromCarne si ya existe un valor
        const precioPromedioCarne = response.data?.hacienda[0]?.precioPromCarne || '';
        setPrecioPromCarne(precioPromedioCarne);
      } catch (error) {
        console.error('Error al cargar datos de la empresa:', error);
        message.error('Error al cargar los datos de la empresa');
      }
    };

    if (empresaId) {
      fetchEmpresaData();
    }
  }, [empresaId]);

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('Solo se permiten archivos de tipo imagen.');
        return false;
      }
      setRemates(file);
      return false;
    },
    fileList: remates ? [remates] : [],
  };

  const handleUpload = async () => {
    if (!remates && !precioPromCarne) {
      message.warning('Por favor selecciona al menos una imagen o ingresa un precio antes de subir.');
      return;
    }

    setLoading(true);
    const formData = new FormData();

    formData.append('section', 'hacienda');
    if (remates) {
      formData.append('remates', remates);
    }
    if (precioPromCarne) {
      formData.append('precioPromCarne', precioPromCarne);
    }

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/empresa/${empresaId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      message.success('Datos actualizados exitosamente.');
      setEmpresaData(response.data);
      setRemates(null);
      setPrecioPromCarne(response.data?.hacienda[0]?.precioPromCarne || '');
    } catch (error) {
      console.error('Error al actualizar los datos:', error);
      message.error('Hubo un error al subir los datos.');
    } finally {
      setLoading(false);
    }
  };

  const renderPreview = (file, imageUrl) => {
    if (file) {
      return (
        <Image
          src={URL.createObjectURL(file)}
          alt="Vista previa"
          style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}
        />
      );
    } else if (imageUrl) {
      return (
        <Image
          src={`${process.env.REACT_APP_S3_URL}/${imageUrl}`}
          alt="Imagen actual"
          style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}
        />
      );
    }
    return null;
  };

  return (
    <div className="p-4">
      <Card title="Hacienda" className="mb-4">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Card title="Remates">
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>Seleccionar Imagen</Button>
              </Upload>
              <div style={{ marginTop: '16px' }}>
                {renderPreview(remates, empresaData?.hacienda[0]?.remates)}
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card title="Precio Promedio de Carne">
              <TextArea
                rows={4}
                style={{ width: '100%', marginTop: '16px' }}
                placeholder="Escribe el precio promedio de carne aquí"
                value={precioPromCarne}
                onChange={(e) => setPrecioPromCarne(e.target.value)}
              />
            </Card>
          </Col>
        </Row>

        <Button
          type="primary"
          onClick={handleUpload}
          loading={loading}
          disabled={!remates && !precioPromCarne}
          className="mt-4"
          style={{ marginTop: '16px' }}
        >
          Actualizar
        </Button>
      </Card>
    </div>
  );
};

export default CHaciendaCliente;